import React from "react";
import { Navigate } from "react-router-dom";
import type { Session } from "@supabase/supabase-js";
import { useAuth } from "@/contexts/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, session, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Check if session is expired
  const isSessionExpired = (s: Session | null): boolean => {
    if (!s || !s.expires_at) return true;
    const expiresAt = s.expires_at * 1000; // Convert to milliseconds
    const now = Date.now();
    return now >= expiresAt;
  };

  // Redirect to login if not authenticated or session expired
  if (!user || !session || isSessionExpired(session)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
